import { render } from "./App.vue?vue&type=template&id=2d07b568&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2d07b568&lang=css"
import "./App.vue?vue&type=style&index=1&id=2d07b568&scoped=true&lang=css"

import exportComponent from "/opt/doctorsp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d07b568"]])

export default __exports__